import { StudioState } from "@/store/types/studio.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import Scale from '@/models/scale';

export const state: StudioState = {
    baseHue: 0,
    baseNote: 'C',
    mode: 0,
    selectedColors: [],
    modesArray: [
        "Chromatic", 
        "Lydian", 
        "Ionian", 
        "Mixolydian", 
        "Dorian", 
        "Aeolian", 
        "Phrygian", 
        "Locrian", 
        "Pentatonic Major",
        "Blues Major",
        "Suspended",
        "Pentatonic Minor",
        "Blues Minor"
    ],
    selectedOctave: 5,
    selectedColor: '#ffff00',
    notesArray: ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'],
    scaleNotesArray: ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'],
    scale : new Scale(0, 0),
    menuDisplaying : 'colorMixer',
};

const namespaced = true;

export const StudioModule: Module<StudioState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
}